import { tableMapping } from "../table/definitions";

export const searchTypeOptions = [
    { label: "Mail", value: "mail", artifactType: "DOCUMENT" },
    { label: "Property", value: "property", artifactType: "REAL_PROPERTY" },
    { label: "Parcel", value: "parcel", artifactType: "PARCEL" },
];

export const searchMailTypeOptions = [
    {
        label: "Tax bill (Personal)",
        value: "tax-bill-personal",
        propertyType: "PERSONAL_PROPERTY",
    },
    {
        label: "Tax return (Personal)",
        value: "tax-return-personal",
        propertyType: "PERSONAL_PROPERTY",
    },
    {
        label: "Value notice (Personal)",
        value: "value-notice-personal",
        propertyType: "PERSONAL_PROPERTY",
    },
    {
        label: "Hearing notice (Personal)",
        value: "hearing-notice-personal",
        propertyType: "PERSONAL_PROPERTY",
    },
    {
        label: "Checks (Personal)",
        value: "check-personal",
        propertyType: "PERSONAL_PROPERTY",
    },
    {
        label: "Tax bills (Real)",
        value: "tax-bill-real",
        propertyType: "REAL_PROPERTY",
    },
    {
        label: "Value notice (Real)",
        value: "value-notice-real",
        propertyType: "REAL_PROPERTY",
    },
    {
        label: "Hearing notice (Real)",
        value: "hearing-notice-real",
        propertyType: "REAL_PROPERTY",
    },
    {
        label: "Checks (Real)",
        value: "check-real",
        propertyType: "REAL_PROPERTY",
    },
    {
        label: "Miscellaneous (Real)",
        value: "miscellaneous-real",
        propertyType: "REAL_PROPERTY",
    },
    {
        label: "Miscellaneous (Personal)",
        value: "miscellaneous-personal",
        propertyType: "PERSONAL_PROPERTY",
    },
];

export const formatKeywordSearchRequest = (currentTable, query) => {
    switch (currentTable) {
        case "parcel": {
            return {
                useCase: "KEYWORD_SEARCH",
                businessUseCase: "SMART",
                queryParams: {
                    keyword: query,
                    artifactType: tableMapping[currentTable].artifactType,
                },
            };
        }
        case "property": {
            return {
                useCase: "KEYWORD_SEARCH",
                businessUseCase: "SMART",
                queryParams: {
                    keyword: query,
                    artifactType: tableMapping[currentTable].artifactType,
                },
            };
        }
        default: {
            return {
                useCase: "KEYWORD_SEARCH",
                businessUseCase: "SMART",
                queryParams: {
                    documentType: tableMapping[currentTable]?.documentType,
                    keyword: query,
                    artifactType: "DOCUMENT",
                    associatedPropertyType: tableMapping[currentTable]?.propertyType,
                },
            };
        }
    }
};
